import { create } from 'zustand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';

const defaultState: SourcingReferrerStoreState = {
    referrer_token: ''
}
export const useSourcingReferrerStore = create<SourcingReferrerStoreState & SourcingReferrerStoreAction>()(
    persist(
        (set) => ({
            ...defaultState,
            reset: () => {
                set(() => ({ ...defaultState }))
            }
        }),
        {
            name: 'sourcing-referrer',
            storage: createJSONStorage(() => sessionStorage)
        }
    )
)
export interface SourcingReferrerStoreState {
    referrer_token: string;
}
export interface SourcingReferrerStoreAction {
    reset: () => void;
}